var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChinese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chinese",
    transform: "translate(21155 -2138)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21155 2138)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_138",
    "data-name": "Subtraction 138",
    d: "M2.766,47.76h0L0,41.8a76.06,76.06,0,0,0,11.08-4.062,35.532,35.532,0,0,0,7.8-5.206,26.5,26.5,0,0,1-5.152-6.882A88.435,88.435,0,0,1,8.965,14.186H.572V8.606H19.551V0h6.295V8.606H45.875v5.58H36.91v0a63.745,63.745,0,0,1-4.1,10.509,37.673,37.673,0,0,1-5.626,7.833,36.193,36.193,0,0,0,6.812,4.161c4.629,2.3,11.811,5.079,11.883,5.107l-.005.015c-.228.56-2.248,5.475-2.826,5.475a.094.094,0,0,1-.03,0,93.491,93.491,0,0,1-11.336-4.735A61.07,61.07,0,0,1,22.6,36.695l0,0A48.845,48.845,0,0,1,14.3,42.552,100.069,100.069,0,0,1,2.766,47.76ZM14.4,14.092a58.421,58.421,0,0,0,4.014,8.985,23.7,23.7,0,0,0,4.76,5.768,20.4,20.4,0,0,0,4.609-5.768,47.325,47.325,0,0,0,3.307-8.985Z",
    transform: "translate(-21132.938 2158.473)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinese);
export default __webpack_public_path__ + "static/media/Chinese.1f417835.svg";
export { ForwardRef as ReactComponent };